module.exports = __webpack_public_path__ + "img/61.457f3d93.jpg";